import { createContext } from 'react';

export const KanbanCardContext = createContext(null);
export const KanbanColumnContext = createContext(null);
